import { render, staticRenderFns } from "./liaotian.vue?vue&type=template&id=9b8584b6&scoped=true"
var script = {}
import style0 from "./liaotian.vue?vue&type=style&index=0&id=9b8584b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8584b6",
  null
  
)

export default component.exports